import { SignatureImageImproved } from "../../../utils/SignatureImage";
import React from "react";
export const pathDailyInspectionSchema = [
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Daily Inspection",
        colSpan: 5,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "year",
        isTitleOnly: true,
      },
      {
        title: "Inspected",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "year",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Interior",
        colSpan: 5,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "interior",
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Exterior",
        colSpan: 5,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "exterior",
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "AirBrake",
        colSpan: 5,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "airbrake",
        isValueOnly: true,
      },
    ],
  },
];
export const consistReportSchema = {
  heights: { header1: "50px" },
  classes: { header1: "" },
  inlineData: false,
  minDataRowsCount: 8,
  columns: [
    {
      title: "UNIT NO.",
      colSpan: 9,
      rowSpan: 1,
      centerAlign: true,
      className: "tbl-text-normal",
      accessor: "unitId",
      isTitleOnly: true,
    },
    {
      title: "DEF.",
      colSpan: 2,
      rowSpan: 1,
      centerAlign: true,
      className: "tbl-text-normal",
      accessor: "defect",
      isValueOnly: true,
      formatter: (value) => {
        return value === true ? "✔" : "";
      },
    },
  ],
};

export const userSchema = [
  {
    heights: {
      header1: "60px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Signature",
        colSpan: 6,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "signature1",
        formatter: (value) => {
          return (
            <span>
              <SignatureImageImproved signatureImage={value} width={"350px"} />
            </span>
          );
        },
      },
      {
        title: "Signature",
        colSpan: 6,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "signature2",
        formatter: (value) => {
          return <SignatureImageImproved signatureImage={value} width={"350px"} />;
        },
      },
    ],
  },
  {
    heights: {
      header1: "50px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Badge #",

        colSpan: 3,
        rowSpan: 1,
        bottomAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "badge1",
      },
      {
        title: "Occupation",
        colSpan: 3,
        rowSpan: 1,
        bottomAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "occupation1",
      },

      {
        title: "Badge #",

        colSpan: 3,
        rowSpan: 1,
        bottomAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "badge2",
      },
      {
        title: "Occupation",
        colSpan: 3,
        rowSpan: 1,
        bottomAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "occupation2",
      },
    ],
  },
];
export const userSchemaSingle = [
  {
    heights: {
      header1: "60px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Signature",
        colSpan: 12,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "signature1",
        formatter: (value) => {
          return <SignatureImageImproved signatureImage={value} width={"350px"} />;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Badge #",

        colSpan: 4,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "badge1",
        formatter: (value) => {
          <div style={{ width: "100%", border: "1px solid black" }}>asdas {value}</div>;
        },
      },
      {
        title: "Occupation",
        colSpan: 8,
        rowSpan: 1,
        topAlign: true,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "occupation1",
        formatter: (value) => {
          <div>{value}</div>;
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/PATH/DailyInspectionReport/Schema.jsx